export default () => {
  const headlines = document.querySelectorAll('[component="headline"]');

  headlines.forEach((headline) => {
    const subheadlineChild = headline.querySelector('[child="subheadline"]');

    if (subheadlineChild) {
      const { textSize, textColor } = subheadlineChild.dataset;

      if (textSize) {
        subheadlineChild.style.fontSize = textSize;
      }
      if (textColor) {
        subheadlineChild.style.color = textColor;
      }
    }
  });
};
